import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialLiquiditySummaryConfiguration,
    LiquiditySummaryConfiguration,
} from 'widgets/liquiditySummary/store/configuration/LiquiditySummaryConfiguration';
import { selectLiquiditySummaryState } from 'widgets/liquiditySummary/store/selectors';

export const buildLiquiditySummaryConfigSlice = () =>
    buildConfigSlice<LiquiditySummaryConfiguration>(
        WidgetType.LIQUIDITY_SUMMARY,
        selectLiquiditySummaryState,
        initialLiquiditySummaryConfiguration
    );

export const useLiquiditySummaryConfigSlice = () =>
    useConfigSlice(buildLiquiditySummaryConfigSlice());

export type LiquiditySummaryConfigPayloadType =
    WidgetConfigSliceActionPayloadType<LiquiditySummaryConfiguration>;
